export const strings = {
    userTokenOutdateText: 'Токен авторизации устарел или Вы были авторизованы на другом устройстве',
};
